/**
 * handler-shared.js
 */

import React from 'react';
import {
  IconButton,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { format, addDays } from 'date-fns';
import { Types, LATE_COMPLETION_DAYS } from 'utils/constants';
import { makeLocation } from 'utils/routing';
import { getFilterParamsString } from 'utils/filter-params';
import { dateParamFormat } from 'utils/datetime';
import { UserContext } from 'contexts/user/user-context';
import Icon from 'components/icon';
import DropMenu from 'components/drop-menu';
import NameCell from './name-cell';



export const handlerLateRecordsPath = (handlerId) => {
  const paramsString = getFilterParamsString({ 
    handlers: [handlerId], 
    complete: false,
    endDate: format(addDays(new Date(), -LATE_COMPLETION_DAYS), dateParamFormat) 
  });
  return makeLocation('', 'records', 'basic', { filterParams: paramsString }).pathname;
}


export const handlerTrainingPath = (handlerId) => {
  const paramsString = getFilterParamsString({ 
    handlers: [handlerId], 
    recordGroups: [Types.RecordGroup.TRAINING],
  });
  return makeLocation('', 'records', 'basic', { filterParams: paramsString }).pathname;
}


export const handlerTrainingDetectionPath = (handlerId) => {
  const paramsString = getFilterParamsString({ 
    handlers: [handlerId], 
    recordGroups: [Types.RecordGroup.TRAINING],
    workMode: Types.WorkMode.DETECTION,
    complete: true,
  });
  return makeLocation('', 'records', 'basic', { filterParams: paramsString }).pathname;
}


export const handlerTrainingPatrolPath = (handlerId) => {
  const paramsString = getFilterParamsString({ 
    handlers: [handlerId], 
    recordGroups: [Types.RecordGroup.TRAINING],
    workMode: Types.WorkMode.PATROL,
    complete: true,
  });
  return makeLocation('', 'records', 'basic', { filterParams: paramsString }).pathname;
}


export const handlerDeploymentPath = (handlerId) => {
  const paramsString = getFilterParamsString({ 
    handlers: [handlerId], 
    recordGroups: [Types.RecordGroup.DEPLOYMENT],
    complete: true,
  });
  return makeLocation('', 'records', 'basic', { filterParams: paramsString }).pathname;
}



export const NameContent = (props) => {
  const { member } = props;
  return <NameCell
    id={member.id}
    name={member.name}
    department={member.departmentName}
    supervisors={member.supervisors}
  />;
}


export const Menu = (props) => {
  const { member, onRemove } = props;
  const { user } = React.useContext(UserContext);

  return (
    <DropMenu
      id={`${member.id}-handler-menu`}
      label={<IconButton size='small' data-testtype='menu-button'><Icon type='menu' /></IconButton>}
      items={[{
        id: 'profile',
        icon: 'handler',
        name: 'Profile',
        component: RouterLink,
        to: `${member.id}/profile`,
      }, ...(user.role.isSupervisor
        ? [{
          id: 'history',
          icon: 'history',
          name: 'History',
          component: RouterLink,
          to: `/${member.id}/history`,
        }]
        : []
      ), {
        id: 'dogs',
        icon: 'dog-profile',
        name: 'Dogs',
        component: RouterLink,
        to: `/${member.id}/dogs`,
      }, ...(user.role.isSupervisor? [{
        id: 'billing',
        icon: 'billing',
        name: 'Billing',
        component: RouterLink,
        to: `/${member.id}/billing`
      }] : []), {
        id: 'remove',
        icon: 'delete',
        name: 'Remove ...',
        tooltip: !member.canRemove ? "This handler can't be removed as they're associated with one of your managed supervisors" : '',
        data: member,
        disabled: !member.canRemove,
        onSelect: () => onRemove(
          user.role.isSupervisor ? Types.Role.SUPERVISOR : Types.Role.TRAINER, 
          user.id,
          member.id, {
            userType: 'Handler',
            text: `remove ${member.name} from your list of handlers`
          }
        )
      }]}
    />
  );
}